import React from 'react'
import { Typography } from 'antd'
import { useIntl } from 'react-intl'

import { openSupportChat } from '../../util/open-support-chat'

const CALENDLY_URL = 'https://calendly.com/vacation-tracker/vacation-tracker-setup'

export function SurveyFooter(): JSX.Element {
  const { formatMessage } = useIntl()
  return (
    <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
      <Typography.Title level={4} style={{ marginBottom: 4, textAlign: 'center' }}>
        {formatMessage({ id: 'survey.extendTrial.footer.title' })}
      </Typography.Title>
      <Typography.Paragraph>
        {formatMessage({ id: 'survey.extendTrial.footer.subtitle' })}{' '}
        <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
          {formatMessage({ id: 'survey.extendTrial.footer.calendlyLinkText' })}
        </a>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <a onClick={() => openSupportChat()} style={{ cursor: 'pointer' }}>
          {formatMessage({ id: 'survey.extendTrial.footer.chatPrompt' })}
        </a>
      </Typography.Paragraph>
    </div>
  )
}
